import { fromJS, Map } from 'immutable';

export function request(state, action) {
    let items = state.get('items') || Map();

    action.ids.forEach((id) => {
        items = items.set(
            id,
            (items.get(id) || Map()).set('state', 'IN_PROGRESS')
        );
    });

    return state.set('items', items);
}

export function error(state, action) {
    let items = state.get('items') || Map();

    action.ids.forEach((id) => {
        items = items.set(
            id,
            (items.get(id) || Map())
                .set('state', 'ERROR')
                .set('errors', fromJS(action.errors))
        );
    });

    return state.set('items', items);
}

export function finish(state, action) {
    let items = state.get('items') || Map();

    action.markets.forEach((market) => {
        market.state = 'FINISHED';

        items = items.set(
            market.id,
            fromJS(market)
        );
    });

    return state.set('items', items);
}
